import React from 'react';
import { Tag } from 'antd';
import { FormattedMessage } from 'react-intl';
import theme from 'shared/constants/theme.json';
import { JobStatus, LicenseStatus, PaymentStatus, UserStatus } from 'shared/prisma/types';
import { LoadingOutlined } from '@ant-design/icons';
import messages from './messages';

function getStatusColor(status) {
  switch (status) {
    case 'OK':
    case 'ENDING':
    case UserStatus.Active:
    case LicenseStatus.Active:
    case PaymentStatus.Paid:
    case PaymentStatus.Refunded:
    case JobStatus.Completed:
      return theme['success-color'];
    case UserStatus.Invited:
    case LicenseStatus.Deprecated:
    case PaymentStatus.Invoice:
    case 'SKIPPED':
    case JobStatus.Pending:
    case JobStatus.Running:
    case 'ONGOING':
    case 'UPCOMING':
    case 'REACHED_LIMIT':
    case 'ESTIMATED_REACHED_LIMIT':
    case 'ESTIMATED_EXCEEDED_LIMIT':
      return theme['warning-color'];
    default:
      return theme['error-color'];
  }
}

function getStatusIcon(status) {
  switch (status) {
    case JobStatus.Running:
      return <LoadingOutlined />;
    default:
      return null;
  }
}

const StatusTag = ({ status }) => (
  status ? (
    <Tag color={getStatusColor(status)} icon={getStatusIcon(status)}>
      {messages[status.toLowerCase()] ? <FormattedMessage {...messages[status.toLowerCase()]} /> : status}
    </Tag>
  ) : null
);

export default StatusTag;
